import { isInView } from './utils';

const stickyHeader = {
  header: null as HTMLElement | null,
  mainContent: null as HTMLElement | null,
  line: null as HTMLElement | null,
  lineWrap: null as HTMLElement | null,

  popups: document.querySelectorAll<HTMLElement>('.jsStickyPopup'),
  cartBtn: document.querySelectorAll<HTMLElement>('.jsInView'),

  lastScrollTop: 0,
  initialized: false,

  refreshElements() {
    this.header = document.getElementById('jsStickyHeader');
    this.mainContent = document.getElementById('main-content');
    this.line = document.getElementById('jsCartLine');
    this.lineWrap = document.getElementById('jsLineWrap');

    this.popups = document.querySelectorAll<HTMLElement>('.jsStickyPopup');

    // Refresh because Neto may replace these during a variation change.
    this.cartBtn = document.querySelectorAll<HTMLElement>('.jsInView');
  },

  init() {
    const start = () => {
      if (this.initialized) return;

      this.initialized = true;
      this.refreshElements();
      this.setClass();
      this.reset();
      this.handleScroll();
    };

    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', start, {
        once: true,
      });
    } else {
      start();
    }
  },

  reset() {
    window.addEventListener('reset', () => {
      this.refreshElements();

      requestAnimationFrame(() => {
        this.setScroll();
      });
    });
  },

  setClass() {
    document.addEventListener(
      'scroll',
      () => {
        this.handleScroll();
      },
      { passive: true },
    );
  },

  handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (this.header && this.mainContent) {
      const scrollingDown = scrollTop > this.lastScrollTop;

      this.header.classList.toggle('down', scrollingDown);
      this.header.classList.toggle('up', !scrollingDown);

      this.mainContent.classList.toggle('down', scrollingDown);
      this.mainContent.classList.toggle('up', !scrollingDown);
    }

    if (scrollTop === 0) {
      this.header?.classList.remove('up', 'down');
      this.mainContent?.classList.remove('up', 'down');
      this.line?.classList.remove('activeClass');

      this.popups.forEach((popup) => {
        popup.classList.remove('activeScroll');
      });
    } else {
      this.popups.forEach((popup) => {
        popup.classList.add('activeScroll');
      });
    }

    this.lastScrollTop = Math.max(scrollTop, 0);
    this.setScroll();
  },

  setScroll() {
    if (!this.lineWrap || !this.header || !this.cartBtn.length) {
      return;
    }

    const cartBtnInView = Array.from(this.cartBtn).some((button) =>
      isInView(button),
    );

    const shouldShow = window.scrollY > 0 && !cartBtnInView;

    this.lineWrap.classList.toggle('activeClass', shouldShow);
    this.header.classList.toggle('activeLine', shouldShow);
  },
};

export default stickyHeader;
